import { useCallback } from 'react';
import { useAppDispatch } from '../store/configureStore';
import { openDialog as openDialogAction } from '../store/dialogSlice';

let resolveCallback: ((value: boolean) => void) | null = null;

interface DialogOptions {
  title: string;
  content: string;
  confirmText?: string;
  cancelText?: string;
}

export const useDialog = () => {
  const dispatch = useAppDispatch();

  const confirm = useCallback(
    async (options: DialogOptions): Promise<boolean> => {
      return new Promise((resolve) => {
        resolveCallback = resolve;
        dispatch(openDialogAction(options));
      });
    },
    [dispatch]
  );

  const handleConfirm = useCallback(() => {
    if (resolveCallback) {
      resolveCallback(true);
      resolveCallback = null;
    }
  }, []);

  const handleCancel = useCallback(() => {
    if (resolveCallback) {
      resolveCallback(false);
      resolveCallback = null;
    }
  }, []);

  return { confirm, handleConfirm, handleCancel };
};
